<!-- ÉTAPE 1 : REMPLISSAGE DU FORMULAIRE -->
@if (!showSuccessMessage) {
<div>
	<div class="text-xl font-medium mb-3">
		Créez votre compte utilisateur
	</div>
	<!-- Plafond de débit atteint (#1059) -->
	@if (throttledMessage) {
	<div class="mb-3">
		<app-message severity="warn" icon="fa-solid fa-hourglass-half" [title]="throttledMessage.shortText"
			[messages]="[throttledMessage.longText]"></app-message>
	</div>
	}
	<form (ngSubmit)="subscribe()" [formGroup]="form" class="grid">
		<!-- Nom et prénom -->
		<div class="col-12 lg:col-6">
			<input pInputText type="text" formControlName="firstName" placeholder="Prénom" required />
		</div>
		<div class="col-12 lg:col-6">
			<input pInputText type="text" formControlName="lastName" placeholder="Nom" required />
		</div>
		<!-- Email -->
		<div class="col-12 flex flex-column">
			<input pInputText type="email" formControlName="email" placeholder="Adresse email" required />
			@if (form.get('email')?.errors && form.get('email')?.hasError('invalid')) {
			<small class="text-red-500 mt-1">{{
				form.get('email')?.getError('message') }}</small>
			}
		</div>
		<!-- Mot de passe -->
		<div class="col-12 flex flex-column">
			<p-password inputStyleClass="w-full" [feedback]="true" formControlName="password" [toggleMask]="true"
				placeholder="Mot de passe" promptLabel="Robustesse du mot de passe" weakLabel="Faible"
				mediumLabel="Moyen" strongLabel="Fort" required />
			@if (form.get('password')?.errors && form.get('password')?.hasError('invalid')) {
			<small class="text-red-500 mt-1">{{
				form.get('password')?.getError('message') }}</small>
			}
		</div>
		<!-- Confirmations du mot de passe -->
		<div class="col-12 flex flex-column">
			<p-password inputStyleClass="w-full" [feedback]="false" formControlName="confirmPassword"
				[toggleMask]="true" placeholder="Confirmer mot de passe" required />
			@if (form.get('confirmPassword')?.errors && form.get('confirmPassword')?.hasError('invalid')) {
			<small class="text-red-500 mt-1">{{
				form.get('confirmPassword')?.getError('message') }}</small>
			}
		</div>

		<!-- Acceptation des CGU -->
		<div class="col-12 flex flex-column gap-1">
			<div class="flex align-items-center gap-2">
				<p-toggleSwitch formControlName="cguAccepted" inputId="cguAccepted"></p-toggleSwitch>
				<label for="cguAccepted" class="cursor-pointer">
					J'accepte les <a (click)="openCguDialog($event)" class="text-primary cursor-pointer">Conditions Générales d'Utilisation</a>
				</label>
			</div>
			@if (form.get('cguAccepted')?.errors && form.get('cguAccepted')?.hasError('invalid')) {
			<small class="text-red-500">{{ form.get('cguAccepted')?.getError('message') }}</small>
			}
		</div>

		<!-- Acceptation de la Politique de Confidentialité -->
		<div class="col-12 flex flex-column gap-1">
			<div class="flex align-items-center gap-2">
				<p-toggleSwitch formControlName="privacyAccepted" inputId="privacyAccepted"></p-toggleSwitch>
				<label for="privacyAccepted" class="cursor-pointer">
					J'ai pris connaissance de la <a (click)="openPrivacyDialog($event)" class="text-primary cursor-pointer">Politique de Confidentialité</a>
				</label>
			</div>
			@if (form.get('privacyAccepted')?.errors && form.get('privacyAccepted')?.hasError('invalid')) {
			<small class="text-red-500">{{ form.get('privacyAccepted')?.getError('message') }}</small>
			}
		</div>

		<div class="col-12 lg:col-6">
			<!-- Validation -->
			<p-button type="submit" styleClass="w-full" label="Créer mon compte" [rounded]="true" [disabled]="form.invalid"
				[loading]="loading"></p-button>
		</div>
		<div class="col-12 lg:col-6">
			<p-button styleClass="surface-900 text-0 border-900 w-full" type="button" label="Déjà inscrit ?"
				[loading]="loading" [rounded]="true" routerLink="/login"></p-button>
		</div>
	</form>
</div>
}

<!-- ÉTAPE 2 : MESSAGE POUR UTILISATEUR -->
@if (showSuccessMessage) {
<div class="h-29rem flex flex-column">
	<div class="text-xl font-medium mb-3">
		Confirmer votre compte
	</div>
	<div class="flex flex-grow-1 flex-column justify-content-between">
		<div class="text-lg line-height-3 flex flex-column gap-3">
			<div>
				Votre compte est créé, mais il n'est <strong>pas encore actif</strong>.
			</div>
			<div>
				Nous venons d'envoyer un email à <strong>{{ form.get('email')?.value }}</strong>. Ouvrez-le et
				cliquez sur le lien qu'il contient pour activer votre compte.
			</div>
			<div>
				Tant que ce n'est pas fait, vous ne pourrez pas vous connecter. Si l'email n'arrive pas dans les
				minutes qui suivent, vérifiez vos courriers indésirables.
			</div>
		</div>
		<!-- Retour connexion -->
		<div class="grid">
			<div class="col">
				<button pButton class="w-full surface-900 text-0 border-900" type="button"
					label="Revenir à la connexion" routerLink="/login"></button>
			</div>
		</div>
	</div>
</div>
}